import { udpApi } from 'yxt-biz-pc/packages/api';

export const getTree = (params) => {
  return udpApi.get('depts/flattree', { params });
};

export const getTreeChilds = (params) => {
  return udpApi.get('depts/flattree/children/idname', { params });
};

export const treeSearch = (params) => {
  return udpApi.get('depts/flattree/search', { params });
};
